// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nJhz","image":"Header_image__1Ud9K","name":"Header_name__2U5no","info":"Header_info__1e3bg","infoRow":"Header_infoRow__276ba"};